/**************************************************
 * Nombre:       Seccion_Detalle
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import fondo from '../../Recursos/fondo_detalles.png'
import Fondo_Seccion from "./Componentes/SubComponentes/Fondo_Seccion";
import Detalle_Barra_Busqueda from "./Componentes/Detalle_Barra_Busqueda";
import Detalle_Producto from "./Componentes/Detalle_Producto";
import Detalle_Relacionados from "./Componentes/Detalle_Relacionados";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import Home_Refistra_Correo from "./Componentes/Home_Refistra_Correo";

const Seccion_Detalle = () => {
    const {sCell, sTab, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{mb: 10}}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Fondo_Seccion fondo={fondo}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: !masSM ? -40 : -64}}>
                <Detalle_Barra_Busqueda/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: !masSM ? -24 : -40}}>
                <Detalle_Producto/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 4}}>
                <Detalle_Relacionados/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mb: -20}}>
                <Home_Refistra_Correo/>
            </Grid>

        </Grid>
    )

}
export default Seccion_Detalle    